// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__12O7H","info":"Note_info__3gTRd","note":"Note_note__Yjixz","actions":"Note_actions__fDjdX"};